module.exports = __webpack_public_path__ + "media/images/main_logo-a972ccd83a4f685e16f408b0429ee72a.svg";